/* =====================================================
   ONLINEAND.DIRECT theme JS 3/3: predictive search, postcode checker, best-seller tabs.
   ===================================================== */

(function() {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }
  /* Same rule as snippets/olad-display-title.liquid, for JSON-sourced titles */
  function shortTitle(t) { return String(t || '').split(' | ')[0].replace(/^FW ?Style /, ''); }
  var ICON = {
    close: '<svg class="olad-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    check: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4.5 12.5 4.5 4.5 10.5-11"/></svg>',
    minus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
  };

  /* ── PREDICTIVE SEARCH (Shopify /search/suggest.json) ── */
  function initPredictiveSearch() {
    var form = document.querySelector('[data-predictive-search]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var panel = document.getElementById('olad-predictive');
    if (!input || !panel) return;
    var timer = null, active = -1, lastQ = '', ctrl = null;

    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function items() { return $all('[role="option"]', panel); }
    function setActive(i) {
      var list = items(); if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function(el, n) { el.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', list[active].id);
      list[active].scrollIntoView({ block: 'nearest' });
    }
    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [], collections = res.collections || [];
      var html = '', n = 0;
      if (collections.length) {
        html += '<div class="olad-predictive__group" role="presentation">Categories</div>';
        collections.forEach(function(c) {
          html += '<a class="olad-predictive__item" role="option" id="olad-ps-' + (n++) + '" aria-selected="false" href="' + esc(c.url) + '"><span class="olad-predictive__name">' + esc(c.title) + '</span></a>';
        });
      }
      if (products.length) {
        html += '<div class="olad-predictive__group" role="presentation">Products</div>';
        products.forEach(function(p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          var price = p.price ? '£' + parseFloat(p.price).toFixed(2) : '';
          html += '<a class="olad-predictive__item" role="option" id="olad-ps-' + (n++) + '" aria-selected="false" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<span><span class="olad-predictive__name">' + esc(shortTitle(p.title)) + '</span>' +
            (price ? '<span class="olad-predictive__price">' + (p.price_max && p.price_max !== p.price_min ? 'from ' : '') + price + '</span>' : '') + '</span></a>';
        });
      }
      if (!n) html = '<p class="olad-predictive__empty">No matches for "' + esc(q) + '". Try a broader word, like "ottoman" or "pocket sprung".</p>';
      html += '<a class="olad-predictive__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for "' + esc(q) + '"</a>';
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === lastQ && !panel.hidden) return;
      lastQ = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function(r) { return r.json(); })
        .then(function(d) { if (input.value.trim() === q) render(q, d); })
        .catch(function() {});
    }
    input.addEventListener('input', function() { clearTimeout(timer); timer = setTimeout(search, 200); });
    input.addEventListener('focus', function() { if (input.value.trim().length >= 2 && panel.innerHTML) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', function(e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    document.addEventListener('click', function(e) { if (!form.contains(e.target)) close(); });
  }

  /* ── POSTCODE CHECKER ──
     Excluded list comes from Theme settings > Delivery (window.oladConfig.excluded).
     Tokens: an area ("BT", "HS"), a district ("G83") or a district range ("AB30-AB56"). */
  function parseExclusions(text) {
    return String(text || '').toUpperCase().split(/[\s,;]+/).filter(Boolean).map(function(tok) {
      var m = tok.match(/^([A-Z]{1,2})(\d{1,2})-([A-Z]{1,2})?(\d{1,2})$/);
      if (m) return { area: m[1], from: +m[2], to: +m[4] };
      m = tok.match(/^([A-Z]{1,2})(\d{1,2})$/);
      if (m) return { area: m[1], from: +m[2], to: +m[2] };
      if (/^[A-Z]{1,4}$/.test(tok)) return { area: tok, any: true };
      return null;
    }).filter(Boolean);
  }
  function checkPostcode(raw, rules) {
    var pc = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (/^BFPO/.test(pc)) return { ok: false, outward: 'BFPO' };
    var outward = null;
    if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(pc)) outward = pc.slice(0, -3);
    else if (/^[A-Z]{1,2}\d[A-Z\d]?$/.test(pc)) outward = pc;
    if (!outward) return { invalid: true };
    var m = outward.match(/^([A-Z]{1,2})(\d{1,2})/);
    var area = m[1], district = +m[2];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.area !== area) continue;
      if (r.any || (district >= r.from && district <= r.to)) return { ok: false, outward: outward };
    }
    return { ok: true, outward: outward };
  }
  function initPostcodeCheckers() {
    var forms = $all('[data-postcode-check]');
    if (!forms.length) return;
    var cfg = window.oladConfig || {};
    var rules = parseExclusions(cfg.excluded);
    var policy = cfg.policyUrl || '/policies/shipping-policy';
    forms.forEach(function(form) {
      var input = form.querySelector('input[name="postcode"]');
      var out = form.querySelector('.olad-postcode__result');
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var r = checkPostcode(input.value, rules);
        out.className = 'olad-postcode__result';
        if (r.invalid) {
          out.classList.add('olad-postcode__result--err');
          out.textContent = 'Please enter a full UK postcode, for example LS7 2DQ.';
          input.setAttribute('aria-invalid', 'true');
          return;
        }
        input.removeAttribute('aria-invalid');
        if (r.ok) {
          out.classList.add('olad-postcode__result--yes');
          out.innerHTML = ICON.check + ' Yes, we deliver free to ' + esc(r.outward) + '.';
        } else {
          out.classList.add('olad-postcode__result--no');
          out.innerHTML = 'Sorry, our carriers don’t currently deliver to ' + esc(r.outward) + '. <a href="' + esc(policy) + '">See delivery areas</a>.';
        }
      });
    });
  }

  /* ── TABS (best sellers) ── */
  function initTabs() {
    $all('[data-tabs]').forEach(function(root) {
      var tabs = $all('[role="tab"]', root);
      function select(tab, focus) {
        tabs.forEach(function(t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function(t, i) {
        t.addEventListener('click', function() { select(t, false); });
        t.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* ── INIT ── */
  function init() {
    initPredictiveSearch();
    initPostcodeCheckers();
    initTabs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();